












































import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import ListDecorator from '../components/ListDecorator.vue';
import Mixin from '../mixin';

@Component({
  components: { ListDecorator },
})
export default class NewGroup extends Mixin {
  @State private showOrg!: string;
  @State private user!: any;
  @Mutation private setGroup!: (group: any[]) => void;
  private member: any[] = [];
  private name: string = '';
  private pass: string = '';
  private usePass: boolean = true;
  private sortProp: string = '';
  private sortAsc: boolean = false;

  private mounted() {
    if (!this.showOrg && this.user.OrganizationID === '@') {
      this.$router.push('/');
    }
    this.getMember();
    (this.$el.querySelector('#name') as HTMLInputElement).focus();
  }

  private async create(event: any) {
    event.stopPropagation();
    try {
      event.target.disabled = true;
      if (!this.showOrg || this.showOrg.length === 0) {
        this.msg('団体選択をしてください');
        this.$router.push('/');
        return;
      }
      if (this.name.length === 0) {
        this.msg('グループ名称を入力してください');
        (this.$el.querySelector('#name')! as HTMLInputElement).focus();
        return;
      }
      if (this.usePass && this.pass.length === 0) {
        this.msg('パスワードを入力してください');
        (this.$el.querySelector('#pass')! as HTMLInputElement).focus();
        return;
      }
      const publisher: any[] = [];
      this.$el.querySelectorAll('tbody .mdl-checkbox.is-checked').forEach((el) => {
        publisher.push({Name: ((el.parentElement as Element).parentElement as Element).id});
      });
      const body = { Name: this.name, Parent: this.showOrg, Publisher: publisher, Password: '' };
      if (this.usePass) {
        body.Password = this.pass;
      }
      await API.post('api', '/group/new', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        body,
      });
      this.msg('グループ「' + this.name + '」を作成しました');
      this.setGroup(await API.get('api', `/group?id=${this.showOrg}`, {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      }) as any[]);
      this.$router.go(-1);
    } catch (e) {
      if (e.response && e.response.status === 409) {
        this.msg('名称が他のグループと重複しています');
        (this.$el.querySelector('#name') as HTMLInputElement).focus();
        return;
      }
      this.msg(e.message || e);
    } finally {
      event.target.disabled = false;
    }
  }

  private async getMember() {
    try {
      const tmp = await API.get('api', '/member?id=' + this.showOrg, {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      });
      this.member = tmp.filter((m: any) => !m.Admin[this.showOrg]);
    } catch (e) {
      this.msg(e.message || e);
    }
  }

  private async reload(p: (f: () => Promise<void>) => void) {
    p(async () => {
      await this.getMember();
    });
  }

  private sort(prop: string) {
    this.sortProp = prop;
    this.sortAsc = !this.sortAsc;
    this.member.sort((m1, m2) => {
      return (this.sortAsc ? m1[prop] < m2[prop] : m2[prop] < m1[prop]) ? -1 : 1;
    });
  }

}
